<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>

<ng-container [ngSwitch]="tag">
  <a
    *ngSwitchCase="'a'"
    [class]="tagClasses"
    target="_self"
    modeClipboard
    [clipboardText]="clipboardText"
    (clipboardSuccess)="clipboardSuccess.emit()"
    (clipboardError)="clipboardError.emit()"
    capraTooltip
    tooltipSize="mini"
    [tooltipContent]="tooltipContent"
    [tooltipContentIsHtml]="tooltipContentIsHtml"
    [tooltipIsDisabled]="tooltipDisabled"
    [tooltipDelay]="tooltipDelay"
  >
    <ng-container *ngTemplateOutlet="projectedContent"> </ng-container>
  </a>

  <button
    *ngSwitchCase="'button'"
    [class]="tagClasses"
    [disabled]="disabled"
    data-test="clipboard-compat-btn"
    modeClipboard
    modeTrackClick
    [trackClickData]="trackClickData"
    [clipboardText]="clipboardText"
    (clipboardSuccess)="clipboardSuccess.emit()"
    (clipboardError)="clipboardError.emit()"
    capraTooltip
    tooltipSize="mini"
    [tooltipContent]="tooltipContent"
    [tooltipContentIsHtml]="tooltipContentIsHtml"
    [tooltipIsDisabled]="tooltipDisabled"
    [tooltipDelay]="tooltipDelay"
  >
    <ng-container *ngTemplateOutlet="projectedContent"> </ng-container>
  </button>

  <capra-button
    *ngSwitchCase="'capra-button'"
    [class]="tagClasses"
    [disabled]="disabled"
    data-test="clipboard-compat-btn"
    modeClipboard
    modeTrackClick
    [trackClickData]="trackClickData"
    [clipboardText]="clipboardText"
    (clipboardSuccess)="clipboardSuccess.emit()"
    (clipboardError)="clipboardError.emit()"
    capraTooltip
    tooltipSize="mini"
    [tooltipContent]="tooltipContent"
    [tooltipContentIsHtml]="tooltipContentIsHtml"
    [tooltipIsDisabled]="tooltipDisabled"
    [tooltipDelay]="tooltipDelay"
    [text]="text"
    [size]="size"
    [variant]="variant"
    [color]="color"
  >
  </capra-button>

  <div
    *ngSwitchCase="'div'"
    [class]="tagClasses"
    modeClipboard
    [clipboardText]="clipboardText"
    (clipboardSuccess)="clipboardSuccess.emit()"
    (clipboardError)="clipboardError.emit()"
    capraTooltip
    tooltipSize="mini"
    [tooltipContent]="tooltipContent"
    [tooltipContentIsHtml]="tooltipContentIsHtml"
    [tooltipIsDisabled]="tooltipDisabled"
    [tooltipDelay]="tooltipDelay"
  >
    <ng-container *ngTemplateOutlet="projectedContent"> </ng-container>
  </div>

  <li
    *ngSwitchCase="'li'"
    [class]="tagClasses"
    modeClipboard
    [clipboardText]="clipboardText"
    (clipboardSuccess)="clipboardSuccess.emit()"
    (clipboardError)="clipboardError.emit()"
    capraTooltip
    tooltipSize="mini"
    [tooltipContent]="tooltipContent"
    [tooltipContentIsHtml]="tooltipContentIsHtml"
    [tooltipIsDisabled]="tooltipDisabled"
    [tooltipDelay]="tooltipDelay"
  >
    <ng-container *ngTemplateOutlet="projectedContent"> </ng-container>
  </li>
</ng-container>
